import { removeTrailingSlash } from '@/helper/url.helper';

const config = {
  apiURL: removeTrailingSlash(import.meta.env.VITE_API_BASE_URL),
  apiVersion: import.meta.env.VITE_API_VERSION ?? 'v1',
  baseURL: removeTrailingSlash(import.meta.env.VITE_BASE_URL),
  version: 1.0,
  isProduction: import.meta.env.MODE === 'production',
  GBS_CALCULATOR_LINK: 'https://gbs.intuji.com/',
  timesheet: {
    defaultTimeSlotDuration: 15,
    timeSelectionDuration: 5,
  },
};

export default config;
